import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment'; 
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class EncryptDecryptService {

  constructor() { } 
  escapeHtml(text:any) {
    
    if(text=='' || text==undefined || Number.isInteger(text))
    {
       return text;
    }
    let alltext = text.replaceAll('amp;', "");
    return alltext
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
       // .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
        
 }

  decodeHtml(str:any)
{
 if(str!='' && str!=undefined &&!Number.isInteger(str) )
 { 
   var map:any =
   {
       '&amp;': '&',
       '&lt;': '<',
       '&gt;': '>',
     //  '&quot;': '"',
       '&apos;': "'",
       'amp;': '&',
   };
 
   return str.replace(/&amp;|&lt;|&gt;|&apos;|amp;/g, function(m:any) {return map[m];});
}
else
{
 return  str;
}
}

encText(plainText:any) {
  let encKey = environment.apiHashingKey;
  let text = plainText;
  let iv = CryptoJS.enc.Hex.parse(environment.encryptIV);
  return btoa(CryptoJS.AES.encrypt(text, encKey, { iv: iv }).toString());
}

decText(encryptedText:any) {
  encryptedText = atob(encryptedText);
  let encKey = environment.apiHashingKey;
  let iv = CryptoJS.enc.Hex.parse(environment.encryptIV);
  var decryptText = CryptoJS.AES.decrypt(encryptedText, encKey, { iv: iv });
  return decryptText.toString(CryptoJS.enc.Utf8);
}

utf8_to_b64(str:any ) {
 return window.btoa(unescape(encodeURIComponent( str )));
}

b64_to_utf8(str:any ) {
 return decodeURIComponent(escape(window.atob( str )));
}
}
